import {
  CompetenzeProgettoDto,
  CostTypeDto,
  DetailContractExternalCostDto,
  ExternalCostDto,
  FatturaEmessaTabDTO,
  FatturaRicevutaPagedDto,
  ProfiloProfessionaleDto,
  RevenueMonthDto,
  StaffExtendedDto,
  UserDto,
} from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import {
  clearReceivedBillsByCost,
  getAssociatedContracts,
  getCompetenzeComplessive,
  getCompetenzePerAnno,
  getCosts,
  getEmittedBills,
  getReceivedBillsByCost,
  getRoles,
  getUsers,
  resetTeamAndCostsData,
  saveCostsData,
  saveRevenueProgress,
  saveRevenuesToBeConsolidated,
  saveTeamData,
  setFeeRateTable,
} from './actions';

interface InitialState {
  ruoli: ProfiloProfessionaleDto[] | null;
  costi: CostTypeDto[] | null;
  allUsers: UserDto[] | null;
  teamData: Partial<StaffExtendedDto>[] | null | undefined;
  costsData: ExternalCostDto[] | null | undefined;
  revenuesToBeConsolidated: number | null | undefined;
  competenzeAnno: CompetenzeProgettoDto | null | undefined;
  associatedContracts: DetailContractExternalCostDto[] | null | undefined;
  revenueProgress: RevenueMonthDto[] | null | undefined;
  feeRateTable: string;
  emittedBills: FatturaEmessaTabDTO[] | null | undefined;
  receivedBillsByCost: FatturaRicevutaPagedDto | null | undefined;
}

const initialState: InitialState = {
  ruoli: null,
  costi: null,
  allUsers: null,
  teamData: null,
  costsData: null,
  revenuesToBeConsolidated: null,
  competenzeAnno: null,
  associatedContracts: null,
  revenueProgress: null,
  feeRateTable: 'allocations',
  emittedBills: null,
  receivedBillsByCost: null,
};

export const projectDetailReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getRoles.fulfilled, (state, action) => {
      state.ruoli = action.payload?.listaRuoli || [];
    })
    .addCase(getCosts.fulfilled, (state, action) => {
      state.costi = action.payload?.otherCostsList || [];
    })
    .addCase(getUsers.fulfilled, (state, action) => {
      state.allUsers = action.payload?.utenti || [];
    })
    .addCase(saveTeamData, (state, action) => {
      state.teamData = action.payload || null;
    })
    .addCase(saveCostsData, (state, action) => {
      state.costsData = action.payload || null;
    })
    .addCase(resetTeamAndCostsData, (state) => {
      state.teamData = null;
      state.costsData = null;
      state.competenzeAnno = null;
      state.associatedContracts = null;
      state.emittedBills = null;
    })
    .addCase(saveRevenuesToBeConsolidated, (state, action) => {
      state.revenuesToBeConsolidated = action.payload;
    })
    .addCase(getCompetenzeComplessive.fulfilled, (state, action) => {
      state.competenzeAnno = action.payload;
    })
    .addCase(getCompetenzePerAnno.fulfilled, (state, action) => {
      state.competenzeAnno = action.payload;
    })
    .addCase(getAssociatedContracts.fulfilled, (state, action) => {
      state.associatedContracts = action.payload;
    })
    .addCase(saveRevenueProgress, (state, action) => {
      state.revenueProgress = action.payload || null;
    })
    .addCase(setFeeRateTable, (state, action) => {
      state.feeRateTable = action.payload;
    })
    .addCase(getEmittedBills.fulfilled, (state, action) => {
      state.emittedBills = action.payload;
    })
    .addCase(getReceivedBillsByCost.fulfilled, (state, action) => {
      state.receivedBillsByCost = action.payload;
    })
    .addCase(clearReceivedBillsByCost, (state) => {
      state.receivedBillsByCost = undefined;
    });
});
